import { j as s } from "./jsx-runtime-DywqP_6a.js";
import * as d from "react";
import { c as o } from "./cn-dYga0KKN.js";
const t = d.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: r,
    className: o(
      "rounded-xl border bg-card text-card-foreground shadow-xs",
      a
    ),
    ...e
  }
));
t.displayName = "Card";
const i = d.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: r,
    className: o("flex flex-col space-y-1.5 p-6", a),
    ...e
  }
));
i.displayName = "CardHeader";
const c = d.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ s.jsx(
  "h3",
  {
    ref: r,
    className: o("font-semibold leading-none tracking-tight", a),
    ...e
  }
));
c.displayName = "CardTitle";
const m = d.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ s.jsx(
  "p",
  {
    ref: r,
    className: o("text-sm text-muted-foreground", a),
    ...e
  }
));
m.displayName = "CardDescription";
const n = d.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ s.jsx("div", { ref: r, className: o("p-6 pt-0", a), ...e }));
n.displayName = "CardContent";
const f = d.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: r,
    className: o("flex items-center p-6 pt-0", a),
    ...e
  }
));
f.displayName = "CardFooter";
export {
  t as C,
  i as a,
  c as b,
  m as c,
  n as d
};
//# sourceMappingURL=Card-hTy9PAnh.js.map
